import * as Yup from "yup";
import { extractContentFromHTML } from "../../../../../util";

const basicInfoSchema = Yup.object().shape({
  header: Yup.string().max(50, "Can only be 50 characters").required(),
  subheader: Yup.string().max(1000, "Can only be 1000 characters"),
  completionMessage: Yup.string()
    .transform((value) => extractContentFromHTML(value))
    .max(1000, "Can only be 1000 characters")
    .required(),
  actionOrder: Yup.string().required(),
  completionRules: Yup.string().required(),
  status: Yup.string().required(),
  completeAny: Yup.number().when("completionRules", {
    is: (value) => value === "Set Amount",
    then: Yup.number().min(1, "Must be at least one").required(),
    otherwise: Yup.number().nullable().optional(),
  }),
  slug: Yup.string().matches(
    /^[a-z0-9_]+(-[a-z0-9_]+)*$/,
    "Please enter a valid slug"
  ),
});
export default basicInfoSchema;
